export default () => {
    const ua = navigator?.userAgent?.toLowerCase();

    return ua.match(/MicroMessenger/i) == "micromessenger";
}